

import {IScene} from "../../services/factory-service-impl/story.utils";
import {Component, Input} from "@angular/core";
import {SCENE_TYPES_LIST} from "../../enums/e-scene-types";
import {SCENE_TYPES} from "../../enums/e-scene-types";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {isNullOrUndefined, isUndefined} from "util";

declare const $: any;

@Component({
  selector:"nv-scene",
  templateUrl:"./nv-scene.component.html"
})
export class NvSceneComponent{
  SCENES = SCENE_TYPES_LIST;
  SCENE_TYPES = SCENE_TYPES;
  VALUE_TYPE = VALUE_TYPE;
  UI_TEXTS = UI_TEXTS;

  @Input() scene:IScene;

  onSceneTypeChange(){
    let talks:any[] = JP.get(this.scene.params, "/talk");
    let delay:number = JP.get(this.scene.params, "/delay");
    this.scene.params = {
      delay:0,
    };
    if (!isNullOrUndefined(delay))
    {
      JP.set(this.scene.params, "/delay", delay);
    }
    if (this.scene.type != this.SCENE_TYPES.COMICS && !isNullOrUndefined(talks))
    {
      JP.set(this.scene.params, "/talk", talks);
    }
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-scenes/nv-scene.component.ts